export enum Rol {
  SUPERADMIN = 1,
}
